export const InterstitialHeaderComponent = {
  name: '_InterstitialHeader_',
  inputs: [
    {
      name: 'toCheckoutButtonText',
      friendlyName: 'To Checkout Button Text',
      helperText: 'The text displayed in the button.',
      type: 'string',
      defaultValue: 'Continue to Checkout',
      localized: true,
      required: true,
    },
    {
      name: 'toCheckoutButtonUrl',
      friendlyName: 'To Checkout Button URL Override',
      helperText:
        'The URL the button will navigate to. Defaults to the cart page. Whatever path you are putting together with multiple interstitials MUST end at the cart page or you will sever checkout. DO NOT PUT ANYTHING IN THIS FIELD IF YOU DO NOT KNOW EXACTLY WHAT YOU ARE DOING AND ENSURE ALL PATHS END AT THE CART PAGE FOR ALL SEGMENTS OF USERS.',
      type: 'string',
      localized: false,
      required: false,
    },
    {
      name: 'showCartIcon',
      friendlyName: 'Show Cart Icon?',
      helperText: 'Turning this on will display the cart icon.',
      type: 'boolean',
      defaultValue: true,
    },
    {
      name: 'dataAnalytics',
      friendlyName: 'Data Analytics',
      type: 'object',
      subFields: [
        {
          name: 'label',
          friendlyName: 'Analytics Label Prefix',
          helperText:
            'Label provided through to analytics services. Clicked component will be appended. Example: IntHeader will become IntHeader_Continue',
          type: 'string',
          required: true,
          localized: false,
        },
        {
          name: 'category',
          friendlyName: 'Analytics Category',
          helperText: 'Category provided through to analytics services.',
          type: 'string',
          required: true,
          localized: false,
        },
      ],
    },
  ],
} as const;

export default InterstitialHeaderComponent;
